{
  "brandTitle": "VBB PLAY — Живая поддержка",
  "brandShort": "VBB PLAY Поддержка",
  "liveLabel": "VBB PLAY Живая поддержка",
  "online": "Онлайн",
  "offline": "Офлайн",
  "close": "Закрыть",
  "moreOptions": "Дополнительно",
  "closeChat": "Закрыть чат",
  "closeMenu": "Закрыть меню",
  "operator": "Оператор VBB PLAY",
  "removeFile": "Удалить файл",
  "attachFile": "Прикрепить файл",
  "loadFailed": "Не удалось загрузить.",
  "fileTooLarge": "Файл больше 50 МБ.",
  "sendFailed": "Сообщение не отправлено ({{status}})",
  "networkError": "Ошибка сети. Попробуйте снова.",
  "nameRequired": "Укажите имя.",
  "emailInvalid": "Укажите корректный e-mail.",
  "topicRequired": "Выберите тему.",
  "messageRequired": "Кратко опишите проблему.",
  "consentRequired": "Нужно согласие на обработку данных.",
  "requestFailed": "Запрос не отправлен.",
  "messagePlaceholder": "Краткое описание…",
  "sending": "Отправка…",
  "startLive": "Начать чат",
  "ratingFailed": "Не удалось отправить оценку.",
  "ratingPlaceholder": "Короткий отзыв (необязательно)",
  "contactSaveFailed": "Контакты не сохранены.",
  "save": "Сохранить",
  "loginRequired": "Войдите, чтобы писать в живую поддержку.",
  "intakeHint": "Укажите данные, чтобы мы помогли быстрее.",
  "back": "Назад",
  "yourName": "Ваше имя",
  "yourEmail": "Ваш e-mail (Gmail или другой)",
  "emailPlaceholder": "email@пример.com",
  "topicLabel": "Тема обращения",
  "topicSelect": "Выберите…",
  "messageLabel": "Проблема или сообщение",
  "consentLong": "Согласие на обработку персональных данных. С Политикой конфиденциальности ознакомлен(а).",
  "soundOff": "🔊 Выключить звук",
  "soundOn": "🔇 Включить звук",
  "rateOperator": "⭐ Оценить оператора",
  "editContact": "✎ Изменить личные данные",
  "searchingOperator": "🔎 Ищем оператора...",
  "waitingOperator": "⏳ Обращение принято. Ожидайте оператора.",
  "operatorJoined": "Оператор {{name}} присоединился к чату",
  "sendFailedShort": "Не отправлено",
  "retry": "Повторить",
  "cameraShot": "📷 Сделать фото",
  "pickPhoto": "🖼️ Выбрать фото",
  "pickVideo": "🎬 Выбрать видео",
  "pickFile": "📁 Выбрать файл или документ",
  "textPlaceholder": "Текст...",
  "messageAria": "Сообщение",
  "sendAria": "Отправить",
  "emojiAria": "Эмодзи",
  "rateTitle": "Оценить оператора",
  "submitRate": "Отправить",
  "editContactTitle": "Изменить личные данные",
  "cameraPermissionTitle": "Доступ к камере",
  "cameraPermissionBody": "Для фото нужен доступ к камере. Окно браузера может остаться на языке устройства.",
  "allowCamera": "Разрешить",
  "notNow": "Не сейчас",
  "namePlaceholder": "Имя",
  "topic_deposit": "Проблема с депозитом",
  "topic_withdraw": "Проблема с выводом",
  "topic_balance": "Проблема с балансом",
  "topic_game": "Проблема с игрой",
  "topic_bonus": "Проблема с бонусом",
  "topic_account": "Аккаунт / вход",
  "topic_tech": "Техническая проблема",
  "topic_other": "Другой вопрос",
  "fileOpenFailed": "Не удалось открыть файл: {{name}}",
  "retryShort": "Ещё раз",
  "fileLoading": "Загрузка файла: {{name}}",
  "emoji_smileys": "Смайлы",
  "emoji_people": "Жесты",
  "emoji_nature": "Природа",
  "emoji_food": "Еда",
  "emoji_activity": "Спорт",
  "emoji_travel": "Путешествия",
  "emoji_objects": "Предметы",
  "emoji_symbols": "Символы",
  "emoji_flags": "Флаги"
}
